import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/apiService";


export const ValidationAllPageReports = createAsyncThunk(
  "ValidationAllPageReport/ValidationAllPageReports",
  async (reportsStagesGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ValidationAllPageReport/ValidationAllPageReports",
        {
            reportsStagesGuid: reportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ValidateReportStage = createSlice({
  name: "ValidateReportStage",
  initialState: {
    ValidateReportStage: [],
    loadingValidateReportStage: false,
    errorValidateReportStage: null,
  },
  reducers: {
    SetValidateReportStage: (state, action) => {
      state.ValidateReportStage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(ValidationAllPageReports.pending, (state, action) => {
        state.loadingValidateReportStage = true;
        state.ValidateReportStage = action.payload;
        state.errorValidateReportStage = null;
      })
      .addCase(ValidationAllPageReports.fulfilled, (state, action) => {
        state.loadingValidateReportStage = false;
        state.ValidateReportStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidationAllPageReports.rejected, (state, action) => {
        state.loadingValidateReportStage = false;
        state.errorValidateReportStage = action.payload;
      });
  },
});
export const { SetValidateReportStage } = ValidateReportStage.actions;

export default ValidateReportStage.reducer;
